const MuiPaper = {
  variants: [
    {
      props: { variant: "drawer" },
      style: ({ theme }) => ({
        // Note: elevation is set via the elevation prop in Drawer.tsx, not CSS
        backgroundColor: theme.palette.background.default,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "4px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      })
    }
  ]
};
export {
  MuiPaper
};
//# sourceMappingURL=MuiPaper.js.map
